import { render, staticRenderFns } from "./pbTemlpate.vue?vue&type=template&id=810769dc&scoped=true&"
import script from "./pbTemlpate.vue?vue&type=script&lang=js&"
export * from "./pbTemlpate.vue?vue&type=script&lang=js&"
import style0 from "./pbTemlpate.vue?vue&type=style&index=0&id=810769dc&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "810769dc",
  null
  
)

export default component.exports